<mat-form-field *ngIf="model != null">
  <input matInput placeholder="Suchbegriff" [formControl]="searchControl" />
</mat-form-field>
<div class="table-responsive">
  <table [class]="cssClass">
    <ng-content select="colgroup"></ng-content>
    <thead>
    <tr>
      <th *ngFor="let column of columns">
        <ng-template [ngIf]="column.labelText != null">
          {{ column.labelText}}
        </ng-template>
        <ng-template [ngIf]="column.labelText == null">
          <ng-template [cdkPortalOutlet]="column.label"></ng-template>
        </ng-template>
      </th>
    </tr>
    </thead>
    <tbody [ngSwitch]="state">
    <tr *ngSwitchCase="States.LOADING" [@fadeInOut]="'in'">
      <td [attr.colspan]="columns.length">
        <mat-spinner class="center-block"></mat-spinner>
      </td>
    </tr>
    <tr *ngSwitchCase="States.ERROR">
      <td [attr.colspan]="columns.length" class="text-center">
        <mat-icon>error</mat-icon>
        es ist ein Fehler aufgetreten
      </td>
    </tr>

    <ng-template [ngSwitchCase]="States.OK">
      <tr *ngIf="tableData.length == 0" [@fadeInOut]="'in'">
        <td [attr.colspan]="columns.length" class="text-center">
          <mat-icon>error</mat-icon>
          keine Daten verfügbar
        </td>
      </tr>
      <ng-template [ngIf]="tableData.length > 0">
        <tr *ngFor="let record of tableData" [@flyIn]="'in'" (click)="emitRowClick($event, record)">
          <td *ngFor="let column of columns">
            <ng-template [cdkPortalOutlet]="getColumnContent(column.content, record)"></ng-template>
          </td>
        </tr>
      </ng-template>
    </ng-template>

    </tbody>
  </table>
</div>
<app-paginator *ngIf="state == States.OK" [itemCount]="nrOfRecords" [pageSize]="RECORDS_PER_PAGE"
               [page]="pageSubject"></app-paginator>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/data-table/data-table.component.html